import {getPerson} from './getPerson'

export const persons = {
  getPerson,
}
